import type { TrackingMatch, TrackingSearchResponse } from '../schemas/trackingSearch';

// Keyed by the EXACT term, with no normalization of case, hyphens or inner spaces. That is not a
// simplification: whether the real match ignores any of those is an open question in the endpoint
// request, and a mock that guessed generously would let a flow be built on tolerance the server may
// not have. Strictest thing that can be true.
const DATASET: Record<string, TrackingMatch[]> = {
  // Two matches — the tracking of the agreed capture, and the case the coincidences modal exists
  // for: one carrier reusing a code across two parcels. Listed newest first, as the read delivers.
  '1Z2X-AMZ-77104': [
    {
      id: 'a3f1c88e-4d21-4f0a-9c17-2b5e6f10d740',
      tracking: '1Z2X-AMZ-77104',
      storedDate: '2026-06-03T10:12:00Z',
      lockerTimezone: 'Europe/Madrid',
      location: { address: 'C/ Alcalá 482, 28027 Madrid' },
      recipient: { id: 330148, name: 'Lucía Fernández Castro', phone: '+34612348902' },
    },
    {
      id: 'bb7d0925-1c64-4a3e-8f52-90d3a1c7e011',
      tracking: '1Z2X-AMZ-77104',
      storedDate: '2026-05-27T18:40:00Z',
      lockerTimezone: 'Europe/Madrid',
      location: { address: 'C/ Mayor 1, 28013 Madrid' },
      recipient: { id: 330149, name: 'Carlos Ruiz', phone: '+34678221540' },
    },
  ],
  // One match — the happy path, which opens the delivery without ever showing the modal.
  TBA304918274: [
    {
      id: 'c41e77b2-5a08-49d6-b3f1-7e2049aa8c35',
      tracking: 'TBA304918274',
      storedDate: '2026-08-19T09:05:00Z',
      lockerTimezone: 'Europe/Madrid',
      location: { address: 'Av. de la Albufera 21, 28038 Madrid' },
      recipient: { id: 330150, name: 'Marta Gil', phone: '+34600112233' },
    },
  ],
  // No titular AT ALL. The delivery exists and there is no «Usuario» to open it under, which is the
  // whole reason the tab state needs a third kind.
  'SEUR-99120034': [
    {
      id: 'd90a1f4c-72b6-4c8d-a5e3-11f8b6420cd7',
      tracking: 'SEUR-99120034',
      storedDate: '2026-07-11T14:22:00Z',
      lockerTimezone: 'Europe/Madrid',
      location: { address: 'C/ Bravo Murillo 210, 28020 Madrid' },
      recipient: null,
    },
  ],
  // The OTHER branch of «titular no resoluble», and the one that looks resolvable: an account is
  // there, with a name, and its phone was nulled by anonymization — so the tab cannot be keyed by
  // the phone the «Usuario» search resolves by. Two absences that read the same and are not.
  'CTT-4471209X': [
    {
      id: 'e5c3b810-9f47-4b21-8d0a-6a71c9e35b48',
      tracking: 'CTT-4471209X',
      storedDate: '2026-04-02T07:48:00Z',
      lockerTimezone: 'Europe/Lisbon',
      location: { address: 'R. Augusta 24, 1100-053 Lisboa' },
      recipient: { id: 330151, name: 'Usuario anonimizado', phone: null },
    },
  ],
};

export async function searchDeliveriesByTrackingMock(
  tracking: string,
): Promise<TrackingSearchResponse> {
  // Simulate network latency for a realistic dev experience.
  await new Promise((resolve) => setTimeout(resolve, 100));
  const results = DATASET[tracking] ?? [];
  // `count` equals the rows here because no fixture reaches the server's 50-row cap. It stays a
  // separate number rather than `results.length`, so a caller cannot start treating the two as one.
  return { count: results.length, results };
}
